<template>
  <div class="login">
    <!-- <img class="_bg" src="@/assets/images/login_bg.png" alt /> -->
    <div class="l_logo">
      <img src="@/assets/images/login_bg_new.png" alt="">
      <!-- <div>
        <img src="@/assets/images/logo.jpg" alt />
      </div> -->
      <!-- <img class="text-logo" src="@/assets/images/logo_text.png" alt /> -->
    </div>
    <div class="r_con">
      <div class="_center">
        <h3  v-show="loginType != 'wx'">{{ title }}</h3>
        <div style="padding-top: 40px;">
          <div v-show="loginType == 'wx'" id="wx_reg" style="text-align: center;">
          </div>
          <div v-if="loginType != 'wx'" class="form-input">
            <p class="_lab">手机号</p>
            <div class="_input _l">
              <input v-model="account" @blur='account = account.replace(/\s+/g,"")' placeholder="请输入手机号"></input>
            </div>
          </div>
          <div  v-if="loginType == 'phone' || loginType == 'register'" class="form-input">
            <p class="_lab">验证码</p>
            <div class="_input _r">
              <input v-model="password" placeholder="请输入验证码"></input>
              <div class="r_solt">
                <el-link type="primary">获取验证码</el-link>
              </div>
            </div>
          </div>
          <div  v-if="loginType == 'account'" class="form-input">
            <p class="_lab">密码</p>
            <div class="_input _l">
              <i class="icon icon-password" style="width: 14px;"></i>
              <input v-model="password" type="password" placeholder="请输入密码"></input>
            </div>
          </div>
        </div>
        <div v-if="loginType == 'account'" style="text-align: right;font-size: 14px;line-height: 14px;position: absolute;right: 40px;top: 220px;">
          <el-link type="primary">忘记密码</el-link>
        </div>
        <div v-if="loginType != 'wx'" class="btn_con">
          <el-button type="primary" :disabled="loginType == 'register' && !isAgree" @click="goSubmit()">{{ loginType == 'register' ? '注 册' : '登 录' }}</el-button>
        </div>
        <div class="btn_con">
          <el-button v-if="loginType != 'wx'" style="border-color: #409EFF;color:#409EFF;" @click="loginType = 'wx'">使用微信登录</el-button>
          <el-button v-if="loginType != 'phone'" style="border-color: #409EFF;color:#409EFF;" @click="loginType = 'phone'">验证码登录</el-button>
        </div>
        <!-- <div v-if="loginType != 'register'" class="bottom">
          <span>其他登录方式</span>
          <i  @click="loginType = 'wx'" class="icon-wx"></i>
          <el-link v-if="loginType == 'account' || loginType == 'wx'" @click="loginType = 'phone'" type="primary">验证码登录</el-link>
        </div>
        <div v-if="loginType ==  'register'" class="bottom">
          <el-checkbox v-model="isAgree"></el-checkbox><span style="margin-left: 10px;">点击“确认”，即代表同意《用户服务协议》</span>
        </div> -->
        <div v-if="loginType != 'register'" class="register">
          <!-- <span>还没账号？</span><el-link  @click="loginType = 'register'" type="primary">立马注册</el-link> -->
        </div>
        <div v-if="loginType == 'register'" class="register">
          <el-link type="primary" @click="loginType = 'account'">使用已有帐户登录</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/jslibs/utils";
import { mapMutations, mapActions, mapState } from "vuex";
import { login, MobileLogin, ScanLogin } from "@/api/common";
import { wxLoginConfig, fileDomain } from "@/configs";


export default {
  data() {
    return {
      account: "",
      password: "",
      // 状态  账号登录 account  手机登录 phone  注册状态 register  微信状态 wx
      loginType: "phone",
      isAgree: false
    };
  },
  computed: {
    ...mapState(["loginData", "imgDomain"]),
    queryCode () {
      return this.$route.query.code || ''
    },
    title() {
      return {
        account: "帐号密码登录",
        phone: "登录",
        register: "注册账号",
        wx: "扫码登录"
      }[this.loginType];
    }
  },
  watch: {
    loginType() {
      if (this.loginType == 'wx') {
        this.initWxLogin()
      }
    },
    queryCode: {
      handler() {
        if (this.queryCode) {
          this.scanLogin()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(["updateLoginData", "setBucketDomain"]),
    network() {
      if (!this.password) {
        this.$message({
          message: "请输入密码",
          type: "warning"
        });
        return false;
      }
      if (!this.account) {
        this.$message({
          message: "请输入账号",
          type: "warning"
        });
        return false;
      }
      // this.setBucketDomain(res[0].data.BucketDomain);
    },
    goSubmit() {
      // 状态  账号登录 account  手机登录 phone  注册状态 register  微信状态 wx
      // loginType: 'register',
      let verification = '';
      if (!this.password) {
        verification = this.loginType == 'account' ? "请填写密码" : "请填写验证码";
      }
       if (!this.account) {
        verification = "请填写账号";
      }
      if (verification) {
        this.$message({
          message: verification,
          type: "warning"
        });
        return false;
      }
      let body = this.loginType == 'account' ? {
        account: this.account, password: this.password
      } : {
        mobile: this.account, code: this.password
      }
      let api = this.loginType == 'account' ? login : MobileLogin;
       Promise.all([
        // getOss(),
        api(body),
      ]).then((res) => {
        let loginRes = res[0];
        this.setloginData(loginRes)
      });
    },
    scanLogin() {
      ScanLogin({ code: this.queryCode }).then((res) => {
        this.setloginData(res)
      });
    },
    setloginData(loginRes) {
      console.log(loginRes)
      // 临时写死
      // 这里 先吧配置 取出 存储  或 后请求获取
      this.setBucketDomain(fileDomain);
      if (loginRes.result) {
        this.$message({
          message: "登录成功",
          type: "success",
        });
        this.updateLoginData(loginRes.result);
        Utils.setCookie(
          "X-Access-Token",
          loginRes.result.token,
          new Date(loginRes.result.expiry_time)
        );
        Utils.setCookie(
          "adminName",
          loginRes.result.name,
          new Date(loginRes.result.expiry_time)
        );
        if (this.loginData && this.loginData.uuid) {
          this.$router.push({
            name: 'workbench',
          });
          return false;
        }
        this.$router.push({
          name: "login",
        });
      }
    },
    initWxLogin () {
      window.WwLogin({
        "id" : "wx_reg",
        "appid" : wxLoginConfig.appid,
        "agentid" : wxLoginConfig.agentid,
        "redirect_uri" : encodeURIComponent('https://gymoo-project-admin.yhbit.cn/#/login'),
        "state" : "",
        "href" : "",
      });
    }
  },
  mounted() {
  },

};
</script>

<style scoped lang="less">
.login {
  background: #258ef7;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  position: relative;
  ._bg {
    width: 100%;
    height: 100%;
  }
  .l_logo {
    position: absolute;
    top: 50%;
    left: 273px;
    margin-top: -288px;
    > div {
      width: 108px;
      height: 108px;
      border-radius: 6px;
      overflow: hidden;
      display: inline-block;
      position: absolute;
      left: 0;
      top: -30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .r_con {
    box-sizing: border-box;
    width: 600px;
    min-height: 480px;
    background: #ffffff;
    position: absolute;
    right: 0px;
    top: 0;
    margin-top: 0;
    height: 100%;
    padding: 40px 116px 0 124px;
    > h3 {
      color: #333640;
      font-size: 24px;
      line-height: 24px;
      font-weight: Bold;
    }
    .form-input {
      height: 56px;
      position: relative;
      margin-top: 32px;
      background: #F4F7FA;
      border-radius: 4px;
      ._lab {position: absolute;top: -22px;line-height: 20px;color: #475059;font-size: 14px;}
      ._input {
        height: 20px;
        padding-top: 16px;
        position: relative;
        margin-left: 20px;
        input {
          width: 100%;
          left: 20px;
          line-height: 22px;
          font-size: 16px;
          border: 0;
          outline: none;
          background: #F4F7FA;
          &::-webkit-input-placeholder {
            color: #7E858C;
          }
        }
        &._l {
          margin-left: 20px;
          .icon {
            width: 11px;
            height: 16px;
            position: absolute;
            left: -14px;
            top: 18px;
          }
        }
        &._r {
          margin-right: 85px;
          .r_solt {
            width: 85px;
            position: absolute;
            right: -75px;
            text-align: right;
            line-height: 20px;
            top: 15px;
          }
        }
      }
    }
    .btn_con {
      margin-top: 34px;
      .el-button {
        width: 100%;
        line-height: 50px;
        height: 50px;
        padding: 0;
        font-size: 18px;
      }
    }
    .bottom {
      line-height: 22px;
      margin-top: 24px;
      span {
        color: #696969;
        line-height: 22px;
        font-size: 14px;
      }
      position: relative;
      i {
        width: 26px;
        height: 21px;
        margin-left: 16px;
        cursor: pointer;
        position: absolute;
        top: 1px;
        &:active {
          top: 2px;
        }
      }
      .el-link {
        float: right;
      }
    }
    .register {
      line-height: 20px;
      color: #333640;
      font-size: 14px;
      text-align: center;
      // padding-top: 32px;
      margin-top: 32px;
      // border-top: 1px solid #e6e6e6;
    }
    ._center {
      width: 360px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
